<template>
<div>
    <div
        class="modal trader-info acc-rej"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 1440px;">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">DUPLICATE TRADE FOUND</h5>
               <div class="float-right">
                    
                    <button type="button" class="close"  @click="closePopup()">
                        <span aria-hidden="true">&times;</span>
                    </button>
               </div>
              
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    
                <table style="margin-bottom: 60px;" class="table align-items-center table-flush table-hover bidtbl">
                      <thead class="thead-light psticky">
                      <tr>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >ACCOUNT <br> NO</th>
                          <th
                            scope="col" 
                            class="sort text-center"
                            >BUY/SELL </th> 
                            <th 
                              scope="col" 
                              class="sort text-center"
                              >TRADE <br> DATE</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >SETTLEMENT <br> DATE</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >CUSIP</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >QTY</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >PRICE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >PRINCIPAL <br> AMOUNT</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >INTEREST</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >COMMCON <br> AMOUNT</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >REF <br> NO</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >ACCOUNT <br> TYPE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >EXEC <br> BROKER <br>MINOR</th>  
                          <th 
                              scope="col" 
                              class="sort text-center border-right"
                              >FBSI <br>SHORT <br>NAME</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >SETTLED</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >Trader</th>                                         
                      </tr>
                      </thead>
                      <tbody class="list no-cursor">
                      <tr v-if="!tradeData">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr>
                          <td class="text-center">{{tradeData.accountNo}}</td>
                          <td class="text-center">{{tradeData.actionSb}}</td>
                          <td class="text-center">{{moment(tradeData.tradeDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{moment(tradeData.settlementDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{tradeData.cusip}}</td>
                          <td class="text-center">{{tradeData.quantity}}</td>
                          <td class="text-center">{{tradeData.price | currency}}</td>
                          <td class="text-center">{{tradeData.principalAmnt | currency}}</td>
                          <td class="text-center">{{tradeData.interest | currency}}</td>
                          <td class="text-center">{{tradeData.commConcAmount | currency}}</td>
                          <td class="text-center">{{tradeData.referenceNo}}</td>
                          <td class="text-center">{{tradeData.acctType}}</td>
                          <td class="text-center">{{tradeData.execBrokerMinor}}</td>
                          <td class="text-center border-right">{{tradeData.fbsiShortName}}</td>
                          <td class="text-center">{{tradeData.settled}}</td>
                          <td class="text-center">{{tradeData.firstName}}</td>
                      </tr>
                      </tbody>
                  </table>
                  <h4 class="text-warning">Another trade was found in the database with the same reference number (shown above). If you proceed, this trade will be deleted. Do you want to continue?</h4>
                  <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">NO</button>
                    <button type="button" class="btn btn-primary"  @click="$emit('continue')">YES</button>
                </div>
                </div>
            </div>
            
          </div>
        </div>
    </div>
</div>      
</template>
<script>

export default {
    name: 'duplicateTrade',
    props: ['tradeData'],
    data() {
        return {
           

        };
    },
    methods : {
    },
  created(){ 
    
  },
  mounted(){


  }
};
</script>